import React from "react";

import "../Website/styles/Footer.css";
import companyLogo from "../../assets/logo-white-r.png";

const Footer = () => {
  return (
    <footer className="website-footer">

      <div className="footer-top">

        <div className="footer-brand">
          <img
            src={companyLogo}
            alt="GTELINQ"
            className="footer-company-logo"
            style={{ imageRendering: "-webkit-optimize-contrast" }}
          />

          <h2>Genesis Tech Engineers</h2>

          <p>
            Enterprise workforce management platform
            designed for modern organizations.
          </p>

        </div>

        <div className="footer-links">

          <div>
            <h4>Platform</h4>

            <a href="/">Home</a>
           
            {/* <a href="/pricing">Pricing</a> */}
            <a href="/payment-terms">Payment Terms</a>
          </div>



          <div>
            <h4>Support</h4>

            <a href="/help-center">Help Center</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms">Terms</a>
          </div>

        </div>

      </div>
      <div className="footer-bottom">
        © 2026 Genesis Tech Engineers |{" "}
        <a
          href="https://genesistech.co.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-website-link"
        >
          www.genesistech.co.in
        </a>
        . All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;












